import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { hitGetJobPaymentHistoryClientApi } from "../../../../../Redux/Client/GetJobPaymentHistorySlice";
import { hitGetJobPaymentRequestsClientApi } from "../../../../../Redux/Client/GetJobPaymentRequestsSlice";
import { hitUpdateJobPaymentApi } from "../../../../../Redux/Client/UpdateJobPaymentSlice";
import { timeAgo } from "../../../../../Helper/CommonFunctions";
import Loader from "../../../../Loader/Loader"; // adjust the path
import "./Payment.scss";
import { showToast } from "../../../../../Helper/Toast";
import moment from "moment";
import { loadStripe } from "@stripe/stripe-js";
import axios from "axios";
import {stripeKey, ApiBaseUrl} from "../../../../../Utils/Constants";

import {
  AlertCircle,
  CheckCircle,
  Calendar,
  FileText,
  Eye,
  Filter,
  ChevronDown,
  Download,
} from "lucide-react";

const Payment = () => {
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);


  const stripePromise = loadStripe(
    stripeKey
  );

  const handleCheckout = async (amount, jobPaymentId) => {
    setLoading(true);
    const stripe = await stripePromise;

    const response = await axios.post(
      `${ApiBaseUrl}v1/user/createIntentJobPayment`,
      {
        amount: amount * 100, // Amount in cents
        currency: "usd",
        jobPaymentId: jobPaymentId
        // You can add more details here as needed
      },
      {
        headers: {
          Authorization: `${localStorage.getItem("clientToken")}`,
        },
      }
    );
    if (response.data.status === true) {
      setLoading(false);
      window.location.href = response.data.data.url; // Redirect to Stripe Checkout
    } else {
      showToast(response.data.data.message, "error");
      setLoading(false);
    }
  };



  const [paymentHistoryList, setPaymentHistoryList] = useState([]);
  const [paymentRequestsList, setPaymentRequestsList] = useState([]);
  const paymentHistoryData = useSelector(
    (state) => state.getJobPaymentHistoryClientReducer.data
  );
  const paymentRequestsData = useSelector(
    (state) => state.getJobPaymentRequestsClientReducer.data
  );

  useEffect(() => {
    dispatch(hitGetJobPaymentHistoryClientApi({}));
    dispatch(hitGetJobPaymentRequestsClientApi({}));
  }, [dispatch]);

  useEffect(() => {
    if (paymentHistoryData && paymentHistoryData.status === true) {
      setPaymentHistoryList(paymentHistoryData.data);
    }
  }, [paymentHistoryData]);

  useEffect(() => {
    if (paymentRequestsData && paymentRequestsData.status === true) {
      setPaymentRequestsList(paymentRequestsData.data);
    }
  }, [paymentRequestsData]);


  
    //✅ Use your Loader here
    if (loading) {
      return <Loader />;
    }

  const updatePaymentStatus = (paymentId, status) => {
    dispatch(hitUpdateJobPaymentApi({ paymentId, status })).then((response) => {
      if (response.payload && response.payload.status === true) {
        showToast("Payment status updated successfully", "success");
        // Refresh the payment requests list
        dispatch(hitGetJobPaymentRequestsClientApi({}));
        dispatch(hitGetJobPaymentHistoryClientApi({}));
      }
    });
  };

  return (
    <>
      <div className="payments-container">
        <div className="payments-header">
          <h1>Payments</h1>
          <p>
            Manage your payment requests, view transaction history, and request
            refunds
          </p>
        </div>
        {paymentRequestsList && paymentRequestsList.length > 0 ? (
          <div className="payment-requests">
            {paymentRequestsList.map((request) => (
              <div
                className="payment-card"
                style={{ maxWidth: "100%", marginBottom: "15px" }}
              // key={request._id}
              >
                {request.viaStripe === 0 ? (
                  <div className="confirmation-banner">
                    <div className="banner-left">
                      <AlertCircle size={18} />
                      <span>Payment Confirmation Required</span>
                    </div>
                    <div className="banner-right">
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                      >
                        <path
                          d="M8 1L10 6L15 7L11 11L12 16L8 13L4 16L5 11L1 7L6 6L8 1Z"
                          stroke="currentColor"
                          strokeWidth="1.5"
                          fill="none"
                        />
                      </svg>
                      <span>Awaiting Your Confirmation</span>
                    </div>
                  </div>
                ) : (
                  <div className="status-badge"></div>
                )}

                <div className="card-content">
                  <h2 className="service-title">{request.jobId.title}</h2>
                  <p className="professional-name">
                    Professional: {request.professionalId.firstName}{" "}
                    {request.professionalId.lastName}
                  </p>

                  {request.viaStripe === 0 && (
                    <div className="confirmation-box">
                      <div className="confirmation-header">
                        <CheckCircle size={18} />
                        <span>Professional Confirmation:</span>
                      </div>
                      <p className="confirmation-text">
                        Professional marked payment as paid. Please acknowledge
                        receipt.
                      </p>
                    </div>
                  )}

                  <div className="payment-details">
                    <div className="detail-item">
                      <Calendar />
                      <span>
                        {moment(new Date(request.date)).format("MM/DD/YYYY")}
                      </span>
                    </div>
                    <div className="detail-item">
                      <span>
                        {request.type === 1
                          ? "Deposit"
                          : request.type === 2
                            ? "Final"
                            : "Other"}
                      </span>
                    </div>
                    <div className="payment-type">
                      <FileText />
                      <span>
                        {request.mode === 1
                          ? "Cash"
                          : request.mode === 2
                            ? "Check"
                            : request.mode === 3
                              ? "Finance"
                              : "Other"}
                      </span>
                    </div>
                  </div>

                  <div className="amount_sec_top">
                    <div className="amount-section">
                      <p className="amount-label">Amount Paid:</p>
                      <h3 className="amount-value">$ {request.amount}</h3>
                      <p className="amount-disclaimer mb-2">
                        {request.viaStripe === 0
                          ? "By acknowledging, you confirm that this payment was received as stated by the professional."
                          : "Click 'Pay Now' to securely process your payment through Stripe."}
                      </p>
                    </div>
                    {request.viaStripe === 0 ? (
                      <button
                        className="acknowledge-button"
                        onClick={() => updatePaymentStatus(request._id, 1)}
                      >
                        Acknowledge Payment
                      </button>
                    ) : (
                      <button className="acknowledge-button" onClick={() => handleCheckout(request.amount, request._id)}>Pay Now</button>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <p className="no-payment-requests" style={{ textAlign: "center" }}>No payment requests available.</p>
        )}

        <div className="payment-history-container">

          <div className="transactions-list">
            {paymentHistoryList.map((transaction) => (
              <div key={transaction._id} className="transaction-card">
                <div
                  className={`status-icon ${transaction.status === 1 ? "success" : "failed"
                    }`}
                >
                  {transaction.status === 1 ? (
                    <CheckCircle size={24} />
                  ) : (
                    <AlertCircle size={24} />
                  )}
                </div>

                <div className="transaction-content">
                  <div className="transaction-header">
                    <div className="transaction-info">
                      <h3>{transaction.service}</h3>
                      <p className="professional-name">
                        Professional: {transaction.professionalId.firstName}{" "}
                        {transaction.professionalId.lastName}
                      </p>
                    </div>

                    <div className="transaction-amount-area">
                      {transaction.amount && (
                        <div className="transaction-amount">
                          $ {transaction.amount}
                        </div>
                      )}
                      <div className="actions-row">
                        {transaction.status && (
                          <span
                            className={`status-badge ${transaction.statusType}`}
                          >
                            {transaction.status === 1 ? "Successful" : "Failed"}
                          </span>
                        )}
                        {transaction.hasDownload && (
                          <button className="download-button">
                            <Download />
                          </button>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="transaction-meta">
                    <div className="meta-item">
                      <Calendar />
                      <span>{transaction.date}</span>
                    </div>
                    <div className="meta-item">
                      <FileText />
                      <span>
                        {transaction.mode === 1
                          ? "Cash"
                          : transaction.mode === 2
                            ? "Check"
                            : transaction.mode === 3
                              ? "Finance"
                              : "Other"}
                      </span>
                    </div>
                  </div>

                  {transaction.note && (
                    <p className={`transaction-note ${transaction.noteType}`}>
                      {transaction.note.startsWith("Note:") ||
                        transaction.note.startsWith("Reason:")
                        ? transaction.note
                        : `Note: ${transaction.note}`}
                    </p>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default Payment;
